export default __webpack_public_path__ + "static/media/site-vitrine.7a2f103c.png";